import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { chrApi } from '../api/api';

export function useQueryExternalContacts(providerId) {
  return useQuery(['fetchExternalContacts', providerId], () => chrApi('get', `external_contact/provider/${providerId}`, null, null).then((res) => res.data), {
    enabled: !!providerId,
  });
}

export const useExternalContact = () => {
  const [isExternalContact, setIsExternalContact] = useState(null);
  const [externalContactUserId, setExternalContactUserId] = useState(null);

  useEffect(() => {
    const userType = window.localStorage.getItem('__type__');
    setIsExternalContact(userType === 'external_contact');
    setExternalContactUserId(window.localStorage.getItem('__userId__'));
  }, []);

  return { isExternalContact, externalContactUserId };
};
